// Comparison page data
export const comparisons = {
  'custom-web-design-vs-wix': {
    slug: 'custom-web-design-vs-wix',
    competitor: 'Wix',
    title: 'Custom Web Design vs Wix: The Honest 2025 Comparison',
    intro: 'Wix is fine for hobby sites and side projects. But if your business depends on the website for revenue, here is a fair comparison of custom web design vs Wix in 2025.',
    winner: 'Custom Web Design wins on performance, SEO, scalability, ownership, design flexibility and brand differentiation. Wix wins on speed-to-launch and monthly cost for very simple sites.',
    rows: [
      { feature: 'Design flexibility', us: 'Unlimited — built to your exact brand', them: 'Limited to template constraints' },
      { feature: 'Page speed', us: 'Sub-2 second load on 4G', them: '3–6 seconds on average' },
      { feature: 'SEO capability', us: 'Full control of every SEO element', them: 'Locked platform, some restrictions' },
      { feature: 'Ownership', us: 'You own everything, code included', them: 'Locked to Wix platform — cannot migrate' },
      { feature: 'Scalability', us: 'Scales to millions of visitors', them: 'Slows down as content grows' },
      { feature: 'Custom functionality', us: 'Anything you can imagine', them: 'Wix App Market only' },
      { feature: 'Upfront cost', us: '$3,000–$15,000', them: '$180–$600 per year' },
      { feature: 'Ongoing cost', us: '$12–$79 / month hosting', them: '$16–$59 / month locked to Wix' },
      { feature: 'Best for', us: 'Businesses that depend on the site', them: 'Personal projects, hobby sites' },
    ],
  },
  'custom-web-design-vs-squarespace': {
    slug: 'custom-web-design-vs-squarespace',
    competitor: 'Squarespace',
    title: 'Custom Web Design vs Squarespace: The Honest 2025 Comparison',
    intro: 'Squarespace makes beautiful templates. But when your business grows past a portfolio site, the platform limits start biting. Here is the honest comparison.',
    winner: 'Custom Web Design wins on flexibility, speed, integrations and scalability. Squarespace wins on out-of-the-box aesthetics for simple portfolios and creator sites.',
    rows: [
      { feature: 'Design flexibility', us: 'Unlimited', them: 'Excellent within template limits' },
      { feature: 'Page speed', us: 'Consistently fast', them: 'Moderate — script-heavy' },
      { feature: 'SEO capability', us: 'Full control', them: 'Good basics, no advanced control' },
      { feature: 'Ownership', us: 'You own the code and content', them: 'Locked to Squarespace' },
      { feature: 'Custom integrations', us: 'Any tool, any API', them: 'Squarespace Extensions only' },
      { feature: 'eCommerce depth', us: 'Full Shopify, WooCommerce or custom', them: 'Basic to intermediate' },
      { feature: 'Upfront cost', us: '$3,000–$15,000', them: '$192–$588 per year' },
      { feature: 'Best for', us: 'Growing businesses, complex needs', them: 'Portfolios, creators, simple stores' },
    ],
  },
  'custom-web-design-vs-wordpress': {
    slug: 'custom-web-design-vs-wordpress',
    competitor: 'WordPress (DIY)',
    title: 'Custom Web Design vs DIY WordPress: The Honest 2025 Comparison',
    intro: 'WordPress powers 40% of the web — but the “DIY WordPress” experience is very different from a WordPress site professionally designed and developed. Here is the comparison.',
    winner: 'Custom Web Design (whether on WordPress or another stack) wins on performance, security, design and result. DIY WordPress wins on upfront cost — if you have the time and skills.',
    rows: [
      { feature: 'Design quality', us: 'Custom, on-brand, conversion-focused', them: 'Depends on theme + your skills' },
      { feature: 'Page speed', us: 'Optimized to under 2s', them: 'Often 4–10s due to bloated themes' },
      { feature: 'Security', us: 'Hardened at server + code level', them: 'Common target for hacks' },
      { feature: 'Maintenance', us: 'Included in ongoing plans', them: 'You handle updates + backups' },
      { feature: 'SEO', us: 'Advanced technical SEO baked in', them: 'Yoast helps, but you configure everything' },
      { feature: 'Time investment', us: 'Weeks of your time saved', them: '40–150 hours of your own time' },
      { feature: 'Total 3-year cost', us: '$6,000–$20,000 with support', them: '$500–$2,000 + hundreds of your hours' },
      { feature: 'Best for', us: 'Businesses that need it done right', them: 'Technical DIYers with time to spare' },
    ],
  },
};

export const comparisonSlugs = Object.keys(comparisons);
